import React, { useContext, useEffect, useState } from "react";
import { Context } from "../../state/context";

import './translation-page.styles.scss';
import KeysLeftPanel from '../../components/keys-left-panel/keys-left-panel.component';
import TranslationItem from '../../components/translation-item/translation-item.component';
import queryString from "query-string";
import useFetch from '../../api/fetch';

export default function TranslationPage() {
    const { state, dispatch } = useContext(Context);
    const [activeKeyText, setActiveKeyText] = useState("");
    const [languages, setLanguages] = useState([]);
    const fetch = useFetch();

    useEffect(() => {
        setActiveKeyText(state.activeKey.text);
    }, [state.activeKey]);


  useEffect(() => {
      (async () => {
          const languageList = await fetch(`/api/language/list`).then(x => x.json());
          setLanguages(languageList);
        dispatch({ type: 'SET_LANGUAGES', languages: languageList });

      })();
    }, []);

    return (
        <div className={"container-fluid"} id={"trans-list"}>
            <div className="d-flex">
              {languages && languages.length > 0 ?
                <>
                  <KeysLeftPanel languages={languages} />
                  {activeKeyText && <TranslationItem key={state.activeKey.id} item={{
                      key: state.activeKey
                  }} />}
                </>
                :<div className='loading' />
              }
            </div>
        </div>
    )
}
